import React from "react";

const SyncStatusBadge = ({ status, size = "md" }) => {
  const sizeStyles = {
    sm: {
      fontSize: "0.875rem",
      padding: "0.25rem 0.5rem",
    },
    md: {
      fontSize: "0.875rem",
      padding: "0.375rem 0.75rem",
    },
    lg: {
      fontSize: "1rem",
      padding: "0.5rem 1rem",
    },
  };

  const getStatusConfig = (status) => {
    switch (status?.toLowerCase()) {
      case "synced":
      case "complete":
        return {
          bgColor: "#dcfce7",
          textColor: "#166534",
          label: status.toLowerCase() === "complete" ? "Complete" : "Synced",
        };
      case "partial":
        return {
          bgColor: "#fef3c7",
          textColor: "#92400e",
          label: "Partial",
        };
      case "historical":
        return {
          bgColor: "#e0e7ff",
          textColor: "#3730a3",
          label: "Historical",
        };
      case "failed":
        return {
          bgColor: "#fee2e2",
          textColor: "#991b1b",
          label: "Failed",
        };
      case "in_progress":
        return {
          bgColor: "#dbeafe",
          textColor: "#1e40af",
          label: "In Progress",
        };
      case "missing_tutors":
        return {
          bgColor: "#fef3c7",
          textColor: "#92400e",
          label: "Missing Tutors",
        };
      default:
        return {
          bgColor: "#f3f4f6",
          textColor: "#001272",
          label: "Not Synced",
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <span
      style={{
        backgroundColor: config.bgColor,
        color: config.textColor,
        borderRadius: "9999px",
        fontWeight: "500",
        display: "inline-flex",
        alignItems: "center",
        ...sizeStyles[size],
      }}
    >
      {config.label}
    </span>
  );
};

export default SyncStatusBadge;
